import PropTypes from 'prop-types'
import React from 'react'

import { NavBrand } from '../../generic'

import MainMenuButton from './MainMenuButton'
import ShowSearchFormButton from './MainMenuShowSearchFormButton'

const MenuButtons = ({ isJobLandingPage, toggleMainMenu, mobileSearchFormHidden, onShowSearchForm }) => {
  if (isJobLandingPage) {
    return (
      <>
        <MainMenuButton variant='left' onClick={toggleMainMenu} />
        <NavBrand />
        {mobileSearchFormHidden &&
          <ShowSearchFormButton onClick={onShowSearchForm} />}
      </>
    )
  }
  return (
    <>
      <NavBrand />
      <MainMenuButton variant='right' onClick={toggleMainMenu} />
    </>
  )
}

MenuButtons.propTypes = {
  isJobLandingPage: PropTypes.bool,
  toggleMainMenu: PropTypes.func,
  mobileSearchFormHidden: PropTypes.bool,
  onShowSearchForm: PropTypes.func
}

export default MenuButtons
